// src/services/reports/LightingReport.js
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { AGDYSA_LOGO_BASE64 } from "../../assets/logoBase64";
import { FIXTURE_TYPES } from "../../utils/lightingFormulas";

export const generateLightingReport = (inputData, results) => {
  const doc = new jsPDF({
    orientation: "p",
    unit: "mm",
    format: "a4",
  });

  const margin = 20;
  const pageWidth = doc.internal.pageSize.width;
  const rightLimit = pageWidth - margin;
  const contentWidth = pageWidth - (margin * 2);

  // 1. LOGO (18.5mm exactos)
  try {
    const imgProps = doc.getImageProperties(AGDYSA_LOGO_BASE64);
    const logoWidth = 18.5;
    const logoHeight = (imgProps.height * logoWidth) / imgProps.width;
    doc.addImage(AGDYSA_LOGO_BASE64, "PNG", margin, 10, logoWidth, logoHeight);
  } catch (e) {
    console.error("Error logo", e);
  }

  // 2. ENCABEZADO "AGDYSA" (Sombreado y Letra Gruesa)
  doc.setFillColor(240, 240, 240);
  doc.rect(margin + 25, 10, 100, 8, "F"); 
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.setTextColor(30, 90, 58);
  doc.text("AGDYSA", margin + 27, 16);

  // 3. SUBTÍTULO
  doc.setFillColor(248, 248, 248);
  doc.rect(margin + 25, 18, 100, 4, "F");
  doc.setFontSize(7);
  doc.setTextColor(100, 100, 100);
  doc.text("REPORTE TÉCNICO DE DISEÑO LUMÍNICO", margin + 27, 21);

  doc.setDrawColor(30, 90, 58);
  doc.setLineWidth(0.5);
  doc.line(margin, 28, rightLimit, 28);

  // 4. DATOS DEL PROYECTO
  doc.setFontSize(9);
  doc.setTextColor(0, 0, 0);
  doc.text(`Fecha: ${new Date().toLocaleDateString()}`, margin, 36);
  doc.text(`Metodología: Método de Lúmenes (Cavidades Zonales)`, margin, 41);

  // 5. TABLA DE ESPECIFICACIONES TÉCNICAS
  autoTable(doc, {
    startY: 46,
    margin: { left: margin, right: margin },
    head: [["PARÁMETRO DE DISEÑO", "VALOR"]],
    body: [
      ["Dimensiones del Local", `${inputData.length}m x ${inputData.width}m`],
      ["Iluminancia Requerida", `${inputData.targetLux} Lux (lx)`],
      ["Tecnología de Lámpara", inputData.source.toUpperCase()],
      ["Flujo por Luminaria", `${inputData.lumens} Lúmenes`],
      ["Configuración de Grid", `${results.cols} columnas x ${results.rows} filas`]
    ],
    headStyles: { fillColor: [30, 90, 58] },
    theme: "striped"
  });

  // 6. REPRESENTACIÓN GRÁFICA (EL PLANO)
  const finalY = doc.lastAutoTable.finalY + 10;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.text("DISTRIBUCIÓN SUGERIDA DE LUMINARIAS (VISTA DE PLANTA):", margin, finalY);

  // Dibujamos el área del local (Escalado)
  const drawAreaMaxW = 100; // mm
  const drawAreaMaxH = 60;  // mm
  const scale = Math.min(drawAreaMaxW / inputData.width, drawAreaMaxH / inputData.length);
  
  const rectW = inputData.width * scale;
  const rectH = inputData.length * scale;
  const startX = margin + (contentWidth - rectW) / 2; // Centrado horizontal
  const startY = finalY + 5;

  // Fondo del local
  doc.setDrawColor(200);
  doc.setLineWidth(0.2);
  doc.rect(startX, startY, rectW, rectH); // Paredes

  // Dibujamos las luminarias según su forma
  doc.setFillColor(57, 255, 20); // Verde neón AGDYSA
  const shape = FIXTURE_TYPES[inputData.type].shape;

  results.coordsY.forEach(y => {
    results.coordsX.forEach(x => {
      const drawX = startX + (x * scale);
      const drawY = startY + (y * scale);
      
      if (shape === "circle") {
        doc.circle(drawX, drawY, 1.5, "FD");
      } else {
        // Rectángulo proporcional
        const rW = inputData.type === "tube_long" ? 6 : 3;
        doc.rect(drawX - (rW/2), drawY - 1, rW, 2, "FD");
      }
    });
  });

  // 7. RESULTADOS DE DESEMPEÑO (Caja de Resultados)
  const resultBoxY = startY + rectH + 15;
  doc.setFillColor(240, 255, 240);
  doc.rect(margin, resultBoxY, contentWidth, 25, "F");
  
  doc.setTextColor(30, 90, 58);
  doc.setFontSize(12);
  doc.text("DIAGNÓSTICO FINAL:", margin + 5, resultBoxY + 8);
  
  doc.setFontSize(9);
  doc.setTextColor(0, 0, 0);
  doc.text(`Iluminancia Lograda (Em): ${results.achievedLux} lx`, margin + 5, resultBoxY + 15);
  doc.text(`Potencia Total del Sistema: ${results.totalWatts} W`, margin + 5, resultBoxY + 20);
  
  doc.setFont("helvetica", "bold");
  doc.text(`Carga Específica: ${results.wattsPerM2} W/m²`, rightLimit - 45, resultBoxY + 15);
  doc.text(`Total Luminarias: ${results.optimal}`, rightLimit - 45, resultBoxY + 20);

  // Pie de página
  doc.setFont("helvetica", "normal");
  doc.setFontSize(7);
  doc.setTextColor(150);
  doc.text("Este reporte técnico es propiedad de AGDYSA. Los resultados son estimaciones basadas en el método de lúmenes.", margin, 285);

  doc.save(`AGDYSA_Plan_Luminico_${Date.now()}.pdf`);
};
/*<!--© 2026 Todos los derechos reservados Desarrollado por JEMAprod-Tecnologia-->*/